import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventosService {

    private usuarioSubject: BehaviorSubject<any>;
    public usuario$;

    constructor() {
        const usuarioStorage = this.getUsuarioStorage();
        this.usuarioSubject = new BehaviorSubject<any>(usuarioStorage);
        this.usuario$ = this.usuarioSubject.asObservable();
    }

    private getUsuarioStorage() {
        const data = localStorage.getItem('localUsuarioDerminas');
        return data ? JSON.parse(data) : null;
    }

    logou(usuario: any) {
        localStorage.setItem('localUsuarioDerminas', JSON.stringify(usuario));
        this.usuarioSubject.next(usuario);
    }

    logout() {
        localStorage.removeItem('localUsuarioDerminas');
        this.usuarioSubject.next(null);
    }

    get usuarioAtual() {
        return this.usuarioSubject.value;
    }
}